import { getToken, getCookieToken } from '@/utils/globalData'

export default defineNuxtRouteMiddleware((to, from) => {
  // 获取 token（客户端从 localStorage，服务端从 cookie）
  let token = null
  if (process.client) {
    token = getToken()
  } else if (process.server) {
    const headers = useRequestHeaders()
    token = getCookieToken(headers)
  }

  // 如果没有 token，重定向到登录页
  if (!token) {
    return navigateTo({
      path: '/sub/login',
      query: {
        redirect: to.fullPath // 保存原来要去的地址，登录后可以跳回
      }
    })
  }
})

